// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"231":"e3a98a35","828":"16bd8dc4","850":"19562a8d","937":"5af91cc1"}[chunkId] + ".js";
};